<template>
  <v-app>
    <v-navigation-drawer 
      v-model="drawer"
      style="text-align-last: center"
      app
      color="rgb(240, 245, 247)"
    >
      <template v-slot:prepend>
        <img
          class="mt-3"
          src="@/assets/sum_rr1.svg"
          width="140px"
          max-height="65px"
        />
      </template>

      <v-card
        class="mx-auto justify-center"
        width="100%"
        height="100%"
        color="transparent"
        elevation="0"
        tile
      >
        <v-flex down>
          <v-list shaped>
            <v-list-item-group class="" color="gray">
              <template v-for="(item, i) in menuItems">
                <template v-if="item.name !== 'Upute za unos'">
              <v-list-item
                :key="i"
                :to="item.to"
                dense
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content
                  >{{ item.name }}
                </v-list-item-content>
              </v-list-item>
                </template>
              <template v-else >
                <v-subheader :key="i" class="mt-3 grey--text">Korisno</v-subheader>
                <v-list-item
                    :key="i"
                    :href="item.to"
                    :target="'_blank'"
                    dense
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content
                  >{{ item.name }}
                  </v-list-item-content>
                </v-list-item>
              </template>
              </template>
            </v-list-item-group>
          </v-list></v-flex
        >
      </v-card>
      <template v-slot:append><span style="font-size:12px">
        Copyright ©<strong
          ><a
            href="https://sumit.sum.ba/"
            target="_blank"
            style="text-decoration: none"
            >SUMIT</a
          ></strong
        >
        2021</span>
      </template>
    </v-navigation-drawer>
    <nav-bar></nav-bar>
    <v-app-bar app color="primary">
      <v-app-bar-nav-icon
        color="white"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <img
        class="ml-5"
        src="https://matica.sum.ba/img/sumit_white.05727976.svg"
        :height="$vuetify.breakpoint.mdAndUp ? '80px' : '70'"
        :width="$vuetify.breakpoint.mdAndUp ? '80px' : '70'"
      />
      <v-spacer></v-spacer>

      <v-menu offset-y class="ml-2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            v-bind="attrs"
            small
            v-on="on"
            outlined
            border="1px solid blue"
          >
            <v-icon left>mdi-account-circle</v-icon>
            {{ getUser.new_username }}
          </v-btn>
        </template>
        <v-list dense class="pa-0">
          <v-list-item-group>
            <v-list-item
              style="background-color: var(--v-primary-base)"
              @click="logout"
            >
              <v-list-item-subtitle style="color: white"
                ><v-icon color="white" class="mr-1" small>
                  mdi-logout-variant</v-icon
                >
                Odjava</v-list-item-subtitle
              >
            </v-list-item>
          </v-list-item-group></v-list
        >
      </v-menu>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
      <v-snackbar
        :bottom="$vuetify.breakpoint.mdAndUp"
        :top="!$vuetify.breakpoint.mdAndUp"
        timeout="3000"
        right
        v-model="snackbar.state"
        :color="snackbar.color"
        >{{ snackbar.text }}</v-snackbar
      >
    </v-content>
    <!-- <app-footer></app-footer> -->
  </v-app>
</template>

<script>
import "./assets/compiled-icons/open-book-inverted";
import "./assets/compiled-icons/sum-icon";
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";

export default {
  name: "App",
  metaInfo: {
    title: "Radovi - Registar radova",
  },
  components: {},

  data: () => ({
    drawer: true,
    menuItems: [
      {
        name: "Radovi",
        to: "/",
        icon: "mdi-bookshelf",
        children: [],
      },
      {
        name: "Autori",
        to: "/autori",
        icon: "mdi-account-group",
        children: [],
      },
      {
        name: "Izdavači",
        to: "/izdavaci",
        icon: "mdi-office-building",
        children: [],
      },
      {
        name: "Izdanja",
        to: "/izdanja",
        icon: "mdi-book",
        children: [],
      },
      {
        name: "Baze izdanja",
        to: "/baze_izdanja",
        icon: "mdi-folder-table",
        children: [],
      },
      {
        name: "Znanstvena područja",
        to: "/znanstvena_podrucja",
        icon: "mdi-school",
        children: [],
      },
      {
        name: "Tipovi radova",
        to: "/tipovi_radova",
        icon: "mdi-file-document-multiple",
        children: [],
      },
      {
        name: "Statistika",
        to: "/statistika",
        icon: "mdi-chart-box-outline",
        children: [],
      },
      {
        name: "Upute za unos",
        to: "https://pub.sum.ba/dokumenti/Upute_za_unos_radova_u_Registar.pdf",
        icon: "mdi-bookmark-outline",
        children: [],
      },
    ],
  }),
  created() {
    console.log(this.getUser)
  },
  async mounted() {
    this.$store.dispatch("getCountries", { page: 1, search: "" });
    this.$store.dispatch("getTipoviIzdanja", { page: 1, search: "" });
    this.$store.dispatch("getTypesFilter", "");
    this.$store.dispatch("getEditionDatabases", { page: 1, search: "" });
    this.$store.dispatch("getPublishers", { page: 1, search: "" });
    this.$store.dispatch("getJezici");
    waitFor("getIzdanja", async function () {
      await this.$store.dispatch("getIzdanja", { page: 1, search: "" });
    }).apply(this);
    window.addEventListener("resize", () => {
      this.$store.dispatch("setWindowWidth", window.innerWidth);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.$store.dispatch("setWindowWidth", window.innerWidth);
    });
  },
  methods: {
    showNotification() {
      this.$store.dispatch("getNotification", {
        state: true,
        color: "green",
        text: "",
      });
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
  computed: {
    ...mapGetters([
      "getRegistarData",
      "getTypes",
      "getDocuments",
      "getKeywords",
      "getEditions",
      "getEditionDatabases",
      "getForeignAuthors",
      "getTypesFilter",
      "snackbar",
      "hasAdminRights",
      "getDeviceType",
      "getUser",
    ]),
  },
};
</script>

<style lang="scss">
.change_color {
  background-color: rgb(8, 71, 118) !important;
}
.v-dialog{
  overflow-x: hidden !important;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

::-webkit-scrollbar-track-piece {
  background: rgba(66, 190, 180, 0.1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(181, 196, 204, 0.3);
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(181, 196, 204, 0.5);
  transform: scale(1.1);
  cursor: pointer;
}
.v-data-table > .v-data-table__wrapper > table tr th {
    cursor: context-menu !important;
}
table {
  .v-data-table-header {
    background-color: var(--v-accent-base) !important;
  }
}
</style>